import React, { useReducer, useEffect } from "react";
import axios from "axios";
import AuthContext from "./AuthContext";
import AuthReducer from "./AuthReducer";
import queryString from "query-string";
// import setAuthToken from '../../utils/setAuthToken'
import { env } from "../../env";

import {
  USER_LOADING,
  USER_LOADED,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_ERRORS,
  FORGOT_PWD_LINK_SUCCESS,
  FORGOT_PWD_LINK_ERROR,
  LINK_REQUEST,
  RESET_PWD_SUCCESS,
  RESET_PWD_ERROR,
  RESET_PWD_LINK_SUCCESS,
  RESET_AUTH,
} from "../types";

const API_HOST = env.REACT_APP_HMW_API_HOST_NAME;
// const API_HOST = "";

const AuthState = (props) => {
  const loginState = window.localStorage.getItem("login");
  // const { user, token } = JSON.parse(loginState);

  const initialState = {
    token: localStorage.getItem("token") ? localStorage.getItem("token") : "",
    isAuthenticated: localStorage.getItem("token") ? true : false,
    anonymous: false,
    user:
      localStorage.getItem("token") && JSON.parse(loginState)
        ? JSON.parse(loginState).user
        : null,
    loading: false,
    isValidating: false,
    error: null,
    password_reset_link: null,
    reset_token: localStorage.getItem("reset_token"),
  };

  const [state, dispatch] = useReducer(AuthReducer, initialState);

  useEffect(() => {
    const loginState = JSON.stringify(state);
    window.localStorage.setItem("login", loginState);
    console.log("LOGIN state", loginState);
  }, [state]);

  //Reset Context State
  const resetAuthState = () => {
    dispatch({
      type: RESET_AUTH,
      payload: { ...initialState },
    });
  };
  //Login User
  const login = async (formData) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (formData) {
      formData.action = "USER_MANAGEMENT";
      formData.function = "login";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_LOADING,
          payload: { loading: true },
        });
        const res = await axios.post(
          `${API_HOST}/user/authenticate`,
          formData,
          config
        );
        let token = res.headers["token"];
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: res.data.data, token: token },
        });
        resolve(res.data);
      } catch (err) {
        console.log("Error in Login", JSON.stringify(err));
        console.log("Error Msg in Login", err.message);
        // console.log("Error Code in Login", err.response.status);
        dispatch({
          type: LOGIN_FAIL,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Extend session
  const extendSession = async (token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Idle Extend Session");
        dispatch({
          type: USER_LOADING,
          payload: { loading: true },
        });
        const resp = await axios.post(
          `${API_HOST}/user/refreshtoken`,
          {
            action: "USER_MANAGEMENT",
            function: "refresh_token",
            version: "1",
          },
          config
        );
        console.log("Idle Extend Session RESP-->", resp);
        let token = resp.headers["token"];
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: state.user, token: token },
        });
        resolve(resp.data);
      } catch (err) {
        console.log("Idle Error in Extend Session", JSON.stringify(err));
        console.log("Idle Error Msg in Extend Session", err.message);
        dispatch({
          type: LOGIN_FAIL,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Logout
  const logout = async (token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
        // token: token,
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Log out function");
        dispatch({
          type: USER_LOADING,
          payload: { loading: true },
        });
        const resp = await axios.post(
          `${API_HOST}/user/logout`,
          {
            action: "USER_MANAGEMENT",
            function: "logout",
            version: "1",
          },
          config
        );
        console.log("LOGOUT RESP-->", resp);
        // if (resp.data) {
        dispatch({ type: LOGOUT });
        // }
        resolve(resp.data);
      } catch (err) {
        console.log("Error in Login", JSON.stringify(err));
        console.log("Error Msg in Login", err.message);
        dispatch({ type: LOGOUT });
        // dispatch({
        //   type: USER_LOADING,
        //   payload: { loading: false },
        // });
        reject(err);
      }
    });
  };

  const logoutThroughChangePassword = () => {
    dispatch({ type: LOGOUT });
  };

  //Clear Error
  const clearErrors = () => {
    dispatch({ type: CLEAR_ERRORS });
  };

  //Load User Deails
  const loadUser = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (!formData) {
      formData = {};
    }
    if (formData) {
      formData.action = "USER_MANAGEMENT";
      formData.function = "user_details";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_LOADING,
          payload: { loading: true },
        });
        const res = await axios.post(
          `${API_HOST}/user/details`,
          formData,
          config
        );
        let token = res.headers["token"];
        dispatch({
          type: USER_LOADED,
          payload: { user: res.data.data, token: token },
        });
        resolve(res.data.data);
      } catch (err) {
        console.log("Error in Load User", JSON.stringify(err));
        console.log("Error Msg in Load User", err.message);
        // console.log("Error Code in Load User", err.response.status);
        dispatch({
          type: LOGIN_FAIL,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Forgot Password Reset Link
  const requestPasswordResetLink = async (formData) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (formData) {
      formData.action = "USER_MANAGEMENT";
      formData.function = "forgot_password";
      formData.version = "1";
    }

    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: LINK_REQUEST,
          payload: { loading: true },
        });
        const res = await axios.post(
          `${API_HOST}/user/forgotpassword`,
          formData,
          config
        );
        const values = queryString.parse(res.data.data);
        const reset_token = values.token;
        dispatch({
          type: FORGOT_PWD_LINK_SUCCESS,
          payload: {
            password_reset_link: res.data.data,
            reset_token: reset_token,
          },
        });
        resolve(res.data);
      } catch (err) {
        console.log("Error in Request Reset Link", JSON.stringify(err));
        console.log("Error Msg in Request Reset Link", err.message);
        // console.log("Error Code in Request Reset Link", err.response.status);
        dispatch({
          type: FORGOT_PWD_LINK_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Validate Reset Password Link
  const validateResetPasswordLink = async (token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        token: `${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: LINK_REQUEST,
          payload: { loading: true },
        });
        const res = await axios.post(
          `${API_HOST}/user/isTokenValid`,
          {},
          config
        );
        let resToken = res.headers["token"];
        dispatch({
          type: RESET_PWD_LINK_SUCCESS,
          payload: { reset_token: resToken },
        });
        resolve(res.data);
      } catch (err) {
        console.log("Error in Validate Reset Link", JSON.stringify(err));
        console.log("Error Msg in Validate Reset Link", err.message);
        // console.log("Error Code in Validate Reset Link", err.response.status);
        dispatch({
          type: RESET_PWD_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Validate Reset Password Link
  const validateUserToken = async (token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        token: `${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: USER_LOADING,
          payload: { loading: true, isValidating: true },
        });
        const res = await axios.post(
          `${API_HOST}/user/isTokenValid`,
          {},
          config
        );

        if (res && res.data) {
          dispatch({
            type: USER_LOADING,
            payload: { loading: false, isValidating: false },
          });
          resolve(res.data);
        } else {
          dispatch({
            type: RESET_AUTH,
            payload: { ...initialState },
          });
          resolve(res.data);
        }
      } catch (err) {
        console.log("Error in Validate User Token", JSON.stringify(err));
        console.log("Error Msg in Validate User Token", err.message);
        // console.log("Error Code in Validate Reset Link", err.response.status);
        dispatch({
          type: RESET_AUTH,
          payload: { ...initialState, error: err },
        });
        reject(err);
      }
    });
  };
  //Reset Password
  const requestPasswordReset = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "USER_MANAGEMENT";
      formData.function = "new_password";
      formData.version = "1";
    }

    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: LINK_REQUEST,
          payload: { loading: true },
        });
        const res = await axios.post(
          `${API_HOST}/user/newpassword`,
          formData,
          config
        );
        console.log("Reset Result: ", res);
        dispatch({
          type: RESET_PWD_SUCCESS,
        });
        resolve(res.data);
      } catch (err) {
        console.log("Error in Password Reset", JSON.stringify(err));
        console.log("Error Msg in Password Reset", err.message);
        // console.log("Error Code in Password Reset", err.response.status);
        dispatch({
          type: RESET_PWD_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //Change Password
  const changePassword = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "USER_MANAGEMENT";
      formData.function = "update_password";
      formData.version = "1";
    }

    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: LINK_REQUEST,
          payload: { loading: true },
        });
        const res = await axios.post(
          `${API_HOST}/user/updatepassword`,
          formData,
          config
        );
        console.log("Reset Result: ", res);
        dispatch({
          type: RESET_PWD_SUCCESS,
        });
        resolve(res.data);
      } catch (err) {
        console.log("Error in Change Password", JSON.stringify(err));
        console.log("Error Msg in Change Password", err.message);
        // console.log("Error Code in Change Password", err.response.status);
        dispatch({
          type: RESET_PWD_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Update Profile
  const updateProfile = async (formData, token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "USER_MANAGEMENT";
      formData.function = "update_profile";
      formData.version = "1";
    }

    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_LOADING,
          payload: { loading: true },
        });
        const res = await axios.post(
          `${API_HOST}/user/updateprofile`,
          formData,
          config
        );
        console.log("Reset Result: ", res);
        // dispatch({
        //   type: RESET_PWD_SUCCESS,
        // });
        resolve(res.data);
      } catch (err) {
        console.log("Error in Update Profile", JSON.stringify(err));
        console.log("Error Msg in Update Profile", err.message);
        // console.log("Error Code in Update Profile", err.response.status);
        dispatch({
          type: RESET_PWD_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };
  //Un-Registered User
  const loginWithEmail = async (formData) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const user = { ...formData };
    if (formData) {
      formData.action = "USER_MANAGEMENT";
      formData.function = "anonymous_user";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: USER_LOADING,
          payload: { loading: true },
        });
        const res = await axios.post(
          `${API_HOST}/user/anonymoususer`,
          formData,
          config
        );
        let token = res.headers["token"];
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: user, anonymous: true, token: token },
        });
        resolve(res);
      } catch (err) {
        console.log("Error in Login with email", JSON.stringify(err));
        console.log("Error Msg in Login with email", err.message);
        // console.log("Error Code in Login with email", err.response.status);
        dispatch({
          type: LOGIN_FAIL,
          payload: err,
        });
        reject(err);
      }
    });
  };

  const getPublicKey = async (formData) => {
    const config = {
      responseType: "arraybuffer",
    };
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        const res = await axios.get(`${API_HOST}/pbk.key`, config);
        resolve(res);
      } catch (err) {
        console.log("Error in Login with email", JSON.stringify(err));
        console.log("Error Msg in Login with email", err.message);
        // console.log("Error Code in Login with email", err.response.status);
        dispatch({
          type: LOGIN_FAIL,
          payload: err,
        });
        reject(err);
      }
    });
  };

  //http://localhost:8080/user/isTokenValid?token=
  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        anonymous: state.anonymous,
        loading: state.loading,
        isValidating: state.isValidating,
        error: state.error,
        password_reset_link: state.password_reset_link,
        reset_token: state.reset_token,
        resetAuthState,
        login,
        logout,
        clearErrors,
        loadUser,
        requestPasswordResetLink,
        validateResetPasswordLink,
        validateUserToken,
        requestPasswordReset,
        loginWithEmail,
        changePassword,
        updateProfile,
        getPublicKey,
        extendSession,
        logoutThroughChangePassword,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
